import React from "react";
import { StyledSVG } from "../styled";
import { sizes } from "../options";

const NewWindowOpen = ({ variant, size, className }) => {
  return (
    <StyledSVG
      variant={variant}
      className={className}
      size={size}
      viewBox={`0 0 ${sizes[size].width.split("p")[0]} ${sizes[size].height.split("p")[0]}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.55555 2.52779C2.98792 2.52779 2.52777 2.98794 2.52777 3.55556V12.4444C2.52777 13.0121 2.98792 13.4722 3.55555 13.4722H12.4444C13.0121 13.4722 13.4722 13.0121 13.4722 12.4444V9.03704C13.4722 8.62283 13.808 8.28704 14.2222 8.28704C14.6364 8.28704 14.9722 8.62283 14.9722 9.03704V12.4444C14.9722 13.8405 13.8405 14.9722 12.4444 14.9722H3.55555C2.1595 14.9722 1.02777 13.8405 1.02777 12.4444V3.55556C1.02777 2.15951 2.15949 1.02779 3.55555 1.02779H6.96295C7.37716 1.02779 7.71295 1.36357 7.71295 1.77779C7.71295 2.192 7.37716 2.52779 6.96295 2.52779H3.55555ZM9.0278 1.77779C9.0278 1.36357 9.36359 1.02779 9.7778 1.02779H14.2222H14.2222C14.3336 1.02779 14.4394 1.05208 14.5344 1.09565C14.592 1.12197 14.6468 1.15595 14.6975 1.19759C14.7388 1.23143 14.7764 1.26959 14.8096 1.31137C14.8404 1.35011 14.8669 1.3912 14.889 1.43396C14.9422 1.53695 14.9722 1.65386 14.9722 1.77779V6.22223C14.9722 6.63644 14.6365 6.97223 14.2222 6.97223C13.808 6.97223 13.4722 6.63644 13.4722 6.22223V3.5884L6.75253 10.3081C6.45964 10.601 5.98476 10.601 5.69187 10.3081C5.39898 10.0152 5.39898 9.54034 5.69187 9.24745L12.4115 2.52779H9.7778C9.36359 2.52779 9.0278 2.192 9.0278 1.77779Z"
      />
    </StyledSVG>
  );
};

export default NewWindowOpen;
